<app-header></app-header>
<app-page-title></app-page-title>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">
        <div class="col-lg-12 text-center" style="height: 180px;">
          <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">No SMS Alert Report Found</div>
        </div>
      </div>
    </div>
  </div>
</div>